import { supabase } from '../supabaseClient';

// Update word group's num_words count
export const updateWordGroupCount = async (groupId) => {
  try {
    // Count words in this group
    const { count, error: countError } = await supabase
      .from('words')
      .select('*', { count: 'exact', head: true })
      .eq('group_id', groupId);
    
    if (countError) {
      console.error('Error counting words for group:', countError);
      return;
    }
    
    // Update the word group's num_words
    const { error: updateError } = await supabase
      .from('word_groups')
      .update({ num_words: count || 0 })
      .eq('id', groupId);
    
    if (updateError) {
      console.error('Error updating word group count:', updateError);
    }
  } catch (error) {
    console.error('Error in updateWordGroupCount:', error);
  }
};

// Update module's num_groups and num_words counts
export const updateModuleCounts = async (moduleId) => {
  try {
    // Count word groups in this module
    const { count: groupCount, error: groupCountError } = await supabase
      .from('word_groups')
      .select('*', { count: 'exact', head: true })
      .eq('module_id', moduleId);
    
    if (groupCountError) {
      console.error('Error counting groups for module:', groupCountError);
      return;
    }
    
    // Count total words in this module (across all groups)
    const { count: wordCount, error: wordCountError } = await supabase
      .from('words')
      .select('*', { count: 'exact', head: true })
      .in('group_id', 
        (await supabase
          .from('word_groups')
          .select('id')
          .eq('module_id', moduleId)
        ).data?.map(g => g.id) || []
      );
    
    if (wordCountError) {
      console.error('Error counting words for module:', wordCountError);
      return;
    }
    
    // Update the module's counts
    const { error: updateError } = await supabase
      .from('modules_new')
      .update({ 
        num_groups: groupCount || 0,
        num_words: wordCount || 0
      })
      .eq('id', moduleId);
    
    if (updateError) {
      console.error('Error updating module counts:', updateError);
    }
  } catch (error) {
    console.error('Error in updateModuleCounts:', error);
  }
};

// Update both word group and module counts when words change
export const updateCountsAfterWordChange = async (groupId) => {
  try {
    // Get the module_id for this group
    const { data: group, error: groupError } = await supabase
      .from('word_groups')
      .select('module_id')
      .eq('id', groupId)
      .single();
    
    if (groupError) {
      console.error('Error getting group module_id:', groupError);
      return;
    }
    
    // Update both counts
    await updateWordGroupCount(groupId);
    await updateModuleCounts(group.module_id);
  } catch (error) {
    console.error('Error in updateCountsAfterWordChange:', error);
  }
};

// Update module counts when word groups change
export const updateCountsAfterGroupChange = async (moduleId) => {
  try {
    await updateModuleCounts(moduleId);
  } catch (error) {
    console.error('Error in updateCountsAfterGroupChange:', error);
  }
};
